import { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { TeamSide } from '../liveMatchTypes.ts';

const TIMEOUT_SECONDS = 30;

interface Props {
  team: TeamSide | null;
  teamName: string;
  onClose: () => void;
}

export default function TimeoutOverlay({ team, teamName, onClose }: Props) {
  const [remaining, setRemaining] = useState(TIMEOUT_SECONDS);

  useEffect(() => {
    if (!team) return;
    setRemaining(TIMEOUT_SECONDS);
    const id = setInterval(() => {
      setRemaining((s) => {
        if (s <= 1) { clearInterval(id); onClose(); return 0; }
        return s - 1;
      });
    }, 1000);
    return () => clearInterval(id);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [team]);

  if (!team) return null;

  const progress = (remaining / TIMEOUT_SECONDS) * 100;

  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        bgcolor: 'rgba(0,0,0,0.75)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10,
        gap: 3,
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: '1.4rem', sm: '2rem', md: '2.5rem' },
          fontWeight: 700,
          color: '#FFD700',
          letterSpacing: 2,
          textTransform: 'uppercase',
        }}
      >
        TIMEOUT — {teamName}
      </Typography>

      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          value={progress}
          size={100}
          thickness={5}
          sx={{ color: remaining > 10 ? 'warning.main' : 'error.main' }}
        />
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            sx={{ fontSize: '2rem', fontWeight: 700, color: 'white', fontVariantNumeric: 'tabular-nums' }}
          >
            {remaining}
          </Typography>
        </Box>
      </Box>

      <Button
        variant="outlined"
        onClick={onClose}
        sx={{ color: 'white', borderColor: 'rgba(255,255,255,0.5)', mt: 1 }}
      >
        Fine timeout
      </Button>
    </Box>
  );
}
